/**
 * 云服务类别 产品图表页 图表Item
 *
 * @format
 */

import React, { useRef, useImperativeHandle, forwardRef } from 'react'
import ReactEcharts, { EChartsInstance, EChartsReactProps } from 'echarts-for-react'
import { echartDefaultOption } from './constants'
export interface EchartReactHandle {
  getEchartsInstance: () => EChartsInstance
}
const EchartReact = forwardRef<EchartReactHandle, EChartsReactProps>((props, ref) => {
  const chartRef = useRef(null)
  useImperativeHandle(ref, () => ({
    getEchartsInstance: () => {
      return chartRef.current?.getEchartsInstance()
    }
  }))

  return (
    <ReactEcharts
      ref={chartRef}
      {...props}
      style={{ height: '100%', width: '100%' }}
      option={{
        ...echartDefaultOption,
        ...props.option
      }}
    />
  )
})
export default React.memo(EchartReact)
